import { Scrollbar } from '../core'

$.fn.RelatedProjects = function(item) {
  let self = this

  if (self.data('related-projects')) {
    return self.data('related-projects')
  }

  self.open_btn = $('.project__related-btn')
  self.close_btn = self.find('.related-projects__close-btn')

  self.open = function() {
    self.attr('aria-hidden', 'false')
  }

  self.close = function() {
    self.attr('aria-hidden', 'true')
  }

  self.background_clicked = function(e) {
    if (e.target == e.currentTarget) {
      self.close()
    }
  }

  return function() {
    new Scrollbar(self.find('.related-projects__content-scroller'))
    self.on('click', self.background_clicked)
    self.open_btn.on('click', self.open)
    self.close_btn.on('click', self.close)
    self.data('related-projects', self)
    return self
  }()
}
